<template>
  <div class="progress-bar">
    <p class="progress-bar__text" v-html="freeDeliveryLabel" />
    <div class="progress-bar__wrapper">
      <div class="progress-bar__threshold">{{ configuration.currencySymbol }}0</div>
      <div class="progress-bar__container">
        <div class="progress-bar__pointer" :style="{ width: freeShippingProgressPercentage + '%' }"></div>
      </div>
      <div class="progress-bar__threshold">
        {{ getFormattedPrice(configuration.freeDeliveryThreshold, configuration.currencySymbol) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

import { getFormattedPrice } from './helpers';

const props = defineProps({
  itemsSubtotalPrice: {
    type: Number,
    default: () => 0,
  },
});

const configuration = ref({
  currencySymbol: window.BPN?.cart?.currencySymbol || '',
  freeDeliveryThreshold: window.BPN.cart.freeDeliveryThreshold,
});

const freeShippingProgressPercentage = computed(() => {
  return (props.itemsSubtotalPrice / configuration.value.freeDeliveryThreshold) * 100;
});

const freeDeliveryLabel = computed(() => {
  if (freeShippingProgressPercentage.value >= 100) {
    if (window?.theme?.bfcm?.saleActive) {
      return '🎉 Free Go Bars Unlocked';
    } else {
      return '🎉 Congrats! You’ve unlocked <b>FREE</b> shipping!';
    }
  }

  if (window?.theme?.bfcm?.saleActive) {
    return `You’re <b>${getFormattedPrice(configuration.value.freeDeliveryThreshold - props.itemsSubtotalPrice, configuration.value.currencySymbol)}</b> away from <b>FREE SHIPPING</b> <b>& FREE GO BARS</b> (US Only)`;
  } else {
    return `You’re <b>${getFormattedPrice(configuration.value.freeDeliveryThreshold - props.itemsSubtotalPrice, configuration.value.currencySymbol)}</b> away from <b>FREE SHIPPING</b> (US Only)`;
  }
});

</script>
